import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from '../../core';
import { environment } from 'environments/environment';
import { PagamentoRequest, PagamentoResponse } from 'app/shared/models/ei-models';

@Injectable({
  providedIn: 'root'
})
export class PagamentoService extends BaseService {
  private controllerEndpoint = environment.urlEdducaImobApi.concat('api/Pagamento/');

  constructor(private httpClient: HttpClient) {
    super();
  }

  criarPagamento(request: PagamentoRequest, loader = true): Observable<PagamentoResponse> {
    return this.httpClient.post<PagamentoResponse>(
      this.controllerEndpoint.concat('Criar'),
      request,
      { headers: this.getHeader(loader) }
    );
  }
}